import {subtract} from "common/lib/ext/array";
import {slice} from "common/lib/ext/object";

export default function except(object, keys) {
  return slice(object, subtract(Object.keys(object), keys));
}
